import script from "./DataProviderEntityCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataProviderEntityCard.vue?vue&type=script&lang=ts&setup=true"

import "./DataProviderEntityCard.vue?vue&type=style&index=0&id=49a4e51d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a4e51d"]])

export default __exports__